module.exports = __webpack_public_path__ + "static/img/4103_phase_function_Paper_PointsHejduk_Prediction.c4e79cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4103_phase_function_Paper_PointsHejduk_Prediction.png
// module id = gNJp
// module chunks = 0